import { CurrencyShort, renderAmount } from "./renderAmount"
import { isDefined } from "./typeScriptHelpers"

export const renderAsMoney = (amount: number | undefined, discountUnit: string | undefined | null, currency?: CurrencyShort) => {
    if (discountUnit !== "") {
        return isDefined(amount) ? `${renderAmount({ amount, currency })} / ${discountUnit}` : undefined
    }

    return isDefined(amount) ? renderAmount({ amount, currency }) : undefined
}
